// Cash-fund variant design tokens (Figma: Travel 2025/2026, node 53294-10868).
// These gold/cream values are variant-specific and not part of the shared joykit palette.
//
// Page background — exact Figma fill rgba(253, 251, 246, 1). The banner card uses the same value
// and is separated from the page by its shadow (matching the design).
export const CASH_FUND_PAGE_BACKGROUND = '#FDFBF6';
export const CASH_FUND_GOLD = '#C9A961';
export const CASH_FUND_TAG_GRADIENT = 'linear-gradient(90deg, #DDC58E 0%, #CDAD6B 100%)';
export const CASH_FUND_TAG_BORDER = '#ECDCB2';

// Couple's available cash-fund balance (a TOTAL amount, in major currency units). The fund is
// applied to the whole stay: out-of-pocket total = max(0, stayTotal − balance), and the per-night
// figures are derived from that. Single swap point for the tile pricing and the "Highest Fund
// Savings" sort.
// TODO(TRAV-3348 follow-up): replace this static balance with the real cash-fund balance from BE.
export const CASH_FUND_STATIC_AVAILABLE_BALANCE = 400;
